/*

    s t a t i c s
    Statics

    :description:
    A file to hold onto static pieces of information, abstracted here to keep things tidy.

    Caution, this module should not import any of our code from this repository (packages only).

*/

//
//  :enums:
//  Statics to cover the values that we need to map against enums.
export const ENUM_MODE_DESKTOP = "desktop";
export const ENUM_MODE_MOBILE = "mobile";
export const ENUM_MODES = [ENUM_MODE_DESKTOP, ENUM_MODE_MOBILE];

export const ENUM_PLATFORM_WINDOWS = "windows";
export const ENUM_PLATFORM_IOS = "ios";
export const ENUM_PLATFORM_ANDROID = "android";
export const ENUM_PLATFORM_LINUX = "linux";
export const ENUM_PLATFORMS = [
  ENUM_PLATFORM_WINDOWS,
  ENUM_PLATFORM_IOS,
  ENUM_PLATFORM_ANDROID,
  ENUM_PLATFORM_LINUX,
];

export const ENUM_APP_USER_AGENT_SIGNATURES = [
  "fban", "fbav", "instagram", "snapchat", "electron", "thunderbird", "tiktok", "whatsapp"
]